<template>
  <div class="w-full max-w-sm mx-auto pt-6">
    <div class="font-black text-xl text-center text-blue-800">
      TIKET PESERTA
    </div>
    <div class="p-5 m-3 md:mx-0 mt-6 rounded-lg shadow bg-white text-gray-800">
      <div class="flex items-center justify-between">
        <div class="w-2/3">
          <div class="font-bold leading-normal">
            Olimpiade Nasional
          </div>
          <div class="font-bold leading-normal">
            SBMPTN UTBK 2020
          </div>
        </div>
        <div class="w-1/3 font-bold text-right">
          <div class="leading-normal text-xs font-bold">
            5 April 2020
          </div>
          <div class="leading-normal text-xs font-bold">
            07.00
          </div>
        </div>
      </div>
      <div class="my-4">
        <div class="w-full flex flex-col items-center justify-center">
          <qrcode
            :options="{scale: 8}"
            :value="code" />
          <div class="text-center font-mono font-bold text-lg">
            {{ code }}
          </div>
        </div>
      </div>
      <div class="flex items-start justify-start leading-tight">
        <div class="mb-2 w-1/3">
          <div class="mb-1 text-xs font-medium">
            No. Peserta
          </div>
          <div class="font-bold">
            {{ $sixDigitNumber(id) }}
          </div>
        </div>
        <div class="mb-2 w-2/3">
          <div class="mb-1 text-xs font-medium">
            Nama
          </div>
          <div class="font-bold">
            {{ name }}
          </div>
        </div>
      </div>
      <div class="flex items-start justify-start leading-tight mt-1">
        <div class="mb-2 w-1/3">
          <div class="mb-1 text-xs font-medium">
            Jurusan
          </div>
          <div class="font-bold">
            {{ majorName }}
          </div>
        </div>
        <div
          v-if="cityName"
          class="mb-2 w-2/3">
          <div class="mb-1 text-xs font-medium">
            Kota
          </div>
          <div class="font-bold">
            {{ cityName }}
          </div>
        </div>
      </div>
    </div>
    <div class="text-center hidden md:block">
      <button
        class="mt-3 bg-blue-700 active:bg-blue-600 text-gray-100 font-bold py-2 pl-2 pr-4 rounded focus:outline-none disabled:cursor-not-allowed disabled:opacity-75 align-middle"
        @click="print()">
        <svg
          class="fill-current inline-block w-6 h-6"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"><path d="M399.95 160h-287.9C76.824 160 48 188.803 48 224v138.667h79.899V448H384.1v-85.333H464V224c0-35.197-28.825-64-64.05-64zM352 416H160V288h192v128zm32.101-352H127.899v80H384.1V64z" /></svg>
        <span class="ml-1">Cetak</span>
      </button>
    </div>
  </div>
</template>

<script>
import qrcode from '@chenfengyuan/vue-qrcode';
export default {
  components: {qrcode},
  props: {
    id: {
      validator: (val) => true,
      default: null,
    },
    code: {
      validator: (val) => true,
      default: null,
    },
    name: {
      validator: (val) => true,
      default: null,
    },
    majorName: {
      validator: (val) => true,
      default: null,
    },
    cityName: {
      validator: (val) => true,
      default: null,
    },
  },
  mounted() {
    this.$nextTick(function () {
      this.$store.commit('setPrinting', true);
      this.$store.commit('setCurrentPath', 'profile');
    })
  },
  methods: {
    print() {
      window.print();
    },
  },
};
</script>
